import {HttpClient, HttpHeaders, HttpParams} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {AppLocalStorage} from "app/app-storage-manager/local-storage";
import {AuthHeaderService} from "app/shared/auth-header.service";
import {MiscService} from "app/shared/misc.service";
import {environment} from "environments/environment";
import {Observable} from "rxjs";
import {map, retry, tap} from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class SettingsService {
    constructor(
        private http: HttpClient,
        private miscService: MiscService,
        private authHeaderService: AuthHeaderService
    ) {
        this.constantsHeaders = new HttpHeaders()
        .set("X-APP-ID", `${environment.X_APP_ID}`)
        .set("X-ISSUER-ID", `${environment.X_ISSUER_ID}`);
    }
    private readonly constantsHeaders: HttpHeaders;

    private generateDynamicHeader(payload: any): HttpHeaders {
        const xAuthHeader = this.authHeaderService.generateAuthHeader(payload);
        return new HttpHeaders().set("X-Auth-Signature", xAuthHeader);
    }
    private mergeHeaders(dynamicHeader: HttpHeaders): HttpHeaders {
        return this.constantsHeaders.append("X-Auth-Signature", dynamicHeader.get("X-Auth-Signature"));
    }

    changeBusinessName = (requestBody) =>
        this.http.put(
            `${environment.API_URL}/merchant/name/${this.miscService.getMerchantDetails().merchant_id}`,
            requestBody
        );

    changePassword = (requestBody) =>
        this.http.put(`${environment.API_URL}/merchant/password/${localStorage.getItem("session_id")}`, requestBody);

    // getAccountStatement (from: string, to: string, account_id: string, iso: string, download: boolean = false): Observable<any> {
    //   return this.http.get(`${environment.API_URL}/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`);
    // }
getAccountStatement(
    from: string,
    to: string,
    account_id: string,
    iso: string,
    download: boolean = false,
    is_job: boolean = false,
    email?: string
): Observable<any> {
    const dynamicHeader = this.generateDynamicHeader({});
    const headers = this.mergeHeaders(dynamicHeader);
    
    let params = `?from_date=${from}&to_date=${to}&download=${download}`;
    
    if (is_job) {
        params += `&is_job=true`;
        if (email) {
            params += `&email=${email}`;
        }
    }
    
    return this.http.get(
        `${environment.API_URL2}/xas/v1/transactions/statements/${iso}/${account_id}${params}`,
        {headers}
    );
}
    toggleTwoFactorAuth(merchantId: string, enable: boolean): Observable<any> {
        const payload = {enable};
        const dynamicHeader = this.generateDynamicHeader(payload);
        const headers = this.mergeHeaders(dynamicHeader);
        return this.http.put(`${environment.API_URL2}/xas/v1/merchants/toggle-2fa/${merchantId}`, payload, {headers});
    }

    requestSecureOtp(payload: {email: string; merchant_id: string}): Observable<any> {
        const dynamicHeader = this.generateDynamicHeader(payload);
        const headers = this.mergeHeaders(dynamicHeader);
        return this.http.post(`${environment.API_URL3}/merchants/secure/otp-request`, payload, {headers});
    }

    verifySecureOtp(payload: {email: string; token: string}): Observable<any> {
        const dynamicHeader = this.generateDynamicHeader(payload);
        const headers = this.mergeHeaders(dynamicHeader);
        return this.http.post(`${environment.API_URL3}/merchants/secure/otp-verify`, payload, {headers});
    }

    createUserRoles = (requestBody) => this.http.post(`${environment.API_URL}/merchant/create/role`, requestBody);
    reInviteUser = (merchantId, email) =>
        this.http.post(`${environment.API_URL}/merchant/reinvite/user/${merchantId}/${email}`, {});
    deleteRole = (merchantId, roleId) =>
        this.http.put(`${environment.API_URL}/merchant/update/role/delete/${merchantId}/${roleId}`, {});
    createNewUser = (requestBody) => this.http.post(`${environment.API_URL}/merchant/create/user`, requestBody);
    updateUser = (requestBody) => this.http.put(`${environment.API_URL}/merchant/user/update/details`, requestBody);
    updateUsersRoles = (requestBody) =>
        this.http.put(`${environment.API_URL}/merchant/update/user/access`, requestBody);
    updateRoleDetails = (requestBody) =>
        this.http.put(`${environment.API_URL}/merchant/update/role/details`, requestBody);
    deleteUser = (requestBody) => this.http.put(`${environment.API_URL}/merchant/update/user/access`, requestBody);
    fetchAllUserRoles = (merchant_id) =>
        this.http.get(`${environment.API_URL}/merchant/fetch/roles/${merchant_id}?status=true`);
    fetchAllUsers = (merchant_id, page?: any, limit?: any, filter?: string) =>
        this.http.get(
            `${environment.API_URL}/merchant/fetch/users/${merchant_id}?page=${page}&limit=${limit}&search=${filter}`
        );

    // changePassword = (requestBody) =>
    //   this.http.put(`${environment.API_URL}/merchant/password/${localStorage.getItem('session_id')}`, requestBody);

    validatePassword = (merchantId, email) =>
        this.http.get(`${environment.API_URL}/merchant/user/validate/password/${merchantId}/${email}`);

    // getAccountStatement (from: string, to: string, account_id: string, iso: string, download: boolean = false): Observable<any> {
    //   return this.http.get(`${environment.API_URL}/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`);
    // }
    // getAccountStatement(
    //   from: string,
    //   to: string,
    //   account_id: string,
    //   iso: string,
    //   download: boolean = false
    // ): Observable<any> {
    //   const dynamicHeader = this.generateDynamicHeader({});
    //   const headers = this.mergeHeaders(dynamicHeader);
    //   return this.http.get(
    //     `${environment.API_URL3}/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`,
    //     { headers }
    //   );
    // }

    exportAccountStatement(
        from: string,
        to: string,
        account_id: string,
        iso: string,
        download: boolean = false
    ): Observable<any> {
        return this.http.get(
            `${environment.API_URL2}/xas/v1/admin/transactions/statements/${iso}/${account_id}?from_date=${from}&to_date=${to}&download=${download}`,
            {responseType: "blob" as "json"}
        );
        // return this.httpClient.post(this.baseUrl(`${routes.report}`), payload, {responseType: 'blob' as 'json'})
    }

    generateAccountStatement = (requestBody, documentType, walletNumber) =>
        this.http.post(
            `${environment.API_URL}/document/${documentType}/account_statement/${walletNumber}`,
            requestBody
        );

    getAppSettings = (countryCode: string, identifier?: string, merchant?: string): Observable<any> => {
        let params = new HttpParams();
        if (countryCode) {
            params = params.set("country_code", countryCode);
        }
        if (merchant) {
            params = params.set("merchant", merchant);
        }
        if (identifier) {
            params = params.set("identifier", identifier);
        }

        return this.http.get(`${environment.API_URL2}/xas/v1/accounts/app_settings`, {params}).pipe(retry(1));
    };
    setupAppSettings = (payload: any): Observable<any> => {
        return this.http.post(`${environment.API_URL2}/xas/v1/accounts/app_settings`, payload);
    };

    updateAppSettings = (payload: any, country_code?: string, identifier?: string, merchant?: string): Observable<any> => {
        let params = new HttpParams();
        if (country_code) {
            params = params.set("country_code", country_code);
        }
        if (merchant) {
            params = params.set("merchant", merchant);
        }
        if (identifier) {
            params = params.set("identifier", identifier);
        }
        return this.http.put(`${environment.API_URL2}/xas/v1/accounts/app_settings`, payload, {params});
    };

    // Pending Transactions Methods
    getMomoPendingTransactions(params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/transactions/pending/momo/transactions`, { params: httpParams });
    }

    getPosPendingTransactions(params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/transactions/pending/pos/transactions`, { params: httpParams });
    }

    getCardPendingTransactions(merchantId: string, params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/transactions-service/mastercard/transactions/${merchantId}/pending`, { params: httpParams });
    }

    getAgreement(kycId: string): Observable<any> {
        return this.http.get(`${environment.API_URL2}/user-service/verification/user-data/${kycId}`);
    }

    updateAgreement(kycId: string, sla: any): Observable<any> {
        return this.http.put(`${environment.API_URL2}/user-service/verification/update-kyc/${kycId}`, { sla });
    }
    // Audit Trail Methods
    getAuditLogs(params: any): Observable<any> {
        let httpParams = new HttpParams();
        Object.keys(params).forEach(key => {
            if (params[key]) {
                httpParams = httpParams.set(key, params[key]);
            }
        });
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/audit-logs`, { params: httpParams });
    }

    getAuditLogById(id: string): Observable<any> {
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/audit-logs/${id}`);
    }

    getAuditLogActions(): Observable<any> {
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/audit-logs/actions`);
    }

    getAuditLogModules(): Observable<any> {
        return this.http.get(`${environment.API_URL2}/xas/v1/merchant/audit-logs/modules`);
    }
}
